import { render, staticRenderFns } from "./DingButton.vue?vue&type=template&id=17e15bd1&scoped=true"
import script from "./DingButton.vue?vue&type=script&lang=js"
export * from "./DingButton.vue?vue&type=script&lang=js"
import style0 from "./DingButton.vue?vue&type=style&index=0&id=17e15bd1&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e15bd1",
  null
  
)

export default component.exports